/* global debounce */

if (!customElements.get('predictive-search')) {
  class PredictiveSearch extends HTMLElement {
    constructor() {
      super();
      this.cachedResults = {};
      this.input = this.querySelector('.js-search-input');
      this.productTypeSelect = this.querySelector('.js-search-product-types');
      this.productTypeInput = document.getElementById('product_type_input');
      this.resetBtn = this.querySelector('.js-search-reset');
      this.results = this.querySelector('.js-search-results');
      this.overlay = this.querySelector('.js-search-overlay');
      this.statusEl = this.querySelector('.js-search-status');
      this.loadingText = this.getAttribute('data-loading-text');
      this.addListeners();
    }

    /**
     * Triggers when the web component is removed from the DOM
     */
    disconnectedCallback() {
      this.close();
    }

    addListeners() {
      this.input.addEventListener('focus', this.handleFocus.bind(this));
      //  console.log("CASE 1", this.input.addEventListener('focus', this.handleFocus.bind(this)));
      this.input.addEventListener('input', debounce(this.handleInput.bind(this)));
      //  console.log("CASE 2", this.input.addEventListener('input', debounce(this.handleInput.bind(this))));

      if (this.productTypeSelect) {
        this.productTypeSelect.addEventListener('change', this.handleProductTypeChange.bind(this));
        // console.log("CASE 3")
      }
      this.querySelector('.search').addEventListener('submit', this.handleSubmit.bind(this));
      //  console.log("CASE 4")
    }

    /**
     * Gets the value of the search input field.
     * @returns {string}
     */
    getQuery() {
  let userSearchTerm = this.input.value.trim().toLowerCase();
  // ...existing code...

const corrections = {
    "foot rest": "footrest",
    "icube": "iqube",
    "appache rtr180": "apache rtr 180",
    "intercome helmet": "intercom helmet",
    "n torq": "ntorq",
    "rtr310 tshirt": "rtr 310 tshirt",
    "s20x intercom": "s20x intercom",
    "ntorq gayrd": "ntorq guard",
    "mobile holder": "mobile holder",
    "t s hirt": "t shirt",
    "foot ": "footrest",
    "ic": "icube",
    "air filter": "air filter",
    "mudguard": "guard",
    "shocker": "shock absorber",
    "horn": "horn",
    "iqube charger": "iqube charger",
    "footrest bracket": "footrest",
    "chain spocket": "chain sprocket",
    "clutch cable": "clutch cable",
    "spark plug": "spark plug",
    "ronin mirror": "ronin mirror",
    "stand sensor": "side stand sensor",
    "kill switch": "kill switch",
    "logo": "logo",
    "rtr 200": "rtr 200",
    "clutch seal 110cc metro plus": "110cc metro plus clutch seal",
    "raider front hydrolik rod": "raider front hydraulic rod",
    "accelerator cable": "accelerator cable",
    "jupiter zx body penal": "jupiter zx body panel",
    "tvs 160 master clender": "tvs 160 master cylinder",
    "handel bar": "handlebar",
    "self switch": "self start switch",
    "brace fender": "fender brace",
    "speedometer": "speedometer",
    "apache sticker": "apache sticker",
    "appache rtr180": "apache rtr 180",
    "ntorq air filter": "ntorq air filter",
    "front mudg": "guard",
    "ronin indicator": "ronin indicator",
    "usd forks": "usd fork",
    "ladies handle": "ladies footrest",
    "tyre hugger": "tyre hugger",
    "apache headlight": "apache headlight",
    "indicater": "indicator",
    "front fender": "front fender",
    "clutch wire": "clutch cable",
    "petrol pipe": "fuel pipe",
    "fuel guage": "fuel gauge",
    "mudgard": "guard",
    "breakpad": "brake pad",
    "soccer": "shock absorber",
    "dicky": "dickey",
    "shockup": "shock absorber",
    "damper": "damper",
    "rr unit": "regulator rectifier unit",
    "relay": "relay",
    "mud gard": "guard",
    "sealent": "sealant",
    "mudcard": "guard",
    "berek": "brake",
    "carburettor": "carburetor",
    "ntorq hugger": "hugger",
    "rectifier": "rectifier",
    "tire sealent": "tyre sealant",
    "axle front": "front axle",
    "headligt bulb": "headlight bulb",
    "air filter box": "air filter box",
    "shocker oil": "shock absorber oil",
    "meter sensor": "speedometer sensor",
    "sidr merriers": "side mirror",
    "clutch rubber": "clutch rubber",
    "shokopcer": "shock absorber",
    "front margad": "guard",
    "apache headlamp": "apache headlight",
    "front murdered": "guard",
    "luggage box": "luggage box",
    "meter wire": "speedometer wire",
    "tires ntorque": "ntorq tyre",
    "front shoker": "front shock absorber",
    "ronin mirrors": "ronin mirror",
    "rtr 4v tci unit": "rtr 4v tci unit",
    "raider housing": "raider housing",
    "chain spocat": "chain sprocket",
    "meter cover": "speedometer cover",
    "front mudguard": "guard",
    "flout pin": "float pin",
    "mood boton": "mode button",
    "hazard switch": "hazard switch",
    "half axcel": "half axle",
    "meter cable": "speedometer cable",
    "meter case": "speedometer case",
    "break cables": "brake cable",
    "gear sensor": "gear sensor",
    "raider acceris": "raider accessories",
    "raider indicator": "raider indicator",
    "baby belt": "baby seat belt",
    "led indicators": "led indicator",
    "clutch poly": "clutch pulley",
    "lever guard": "lever guard",
    "mode button": "mode button",
    "kick cover": "kick cover",
    "radeon mirrors": "radeon mirror",
    "silancer bolt": "silencer bolt",
    "jupter nose": "jupiter nose",
    "ballracer": "ball bearing",
    "chen sprocket": "chain sprocket",
    "mood button": "mode button",
    "baby seat": "baby seat",
    "footrest holder": "footrest holder",
    "front shocker": "front shock absorber",
    "break padel": "brake pad",
    "battery 12v 4ah": "12v 4ah battery",
    "allowy well": "alloy wheel",
    "lift merrier": "left mirror",
    "side indicator": "side indicator",
    "chain sporket": "chain sprocket",
    "clutch switch": "clutch switch",
    "front display": "front display",
    "wind cheaters": "wind cheater",
    "disc cover": "disc cover",
    "indicator light": "indicator light",
    "magnetic coil": "ignition coil",
    "start kick": "kick start",
    "leg gaurd": "leg guard",
    "abs cable": "abs cable",
    "mud gaurd": "guard",
    "speeddo meeter": "speedometer",
    "drum brake": "drum brake",
    "tyer hugger": "tyre hugger",
    "tvsraider": "tvs raider",
    "underseat box": "under seat storage box",
    "chene set": "chain set",
    "soccer rtr 160": "rtr 160 shock absorber",
    "clear clutch": "clutch plate",
    "bhai candle pipe": "spark plug",
    "digital metre 4v": "digital speedometer 4v",
    "grey footrest": "grey footrest",
    "pertol pump": "fuel pump",
    "front madgard": "guard",
    "scooty ka sensor": "scooty sensor",
    "numberplate lamp": "number plate light",
    "ntoric tyer": "ntorq tyre",
    "180 meter": "180 speedometer",
    "raider cluch": "raider clutch",
    "clutch shoe": "clutch shoe",
    "intorq headlight": "ntorq headlight",
    "indicator ntorq": "ntorq indicator",
    "airfilter": "air filter",
    "engine cowl": "engine cowl",
    "gair shift assy": "gear shift assembly",
    "wntorq belt": "ntorq belt",
    "self motor": "self starter motor",
    "head doom": "headlight",
    "jupiter garde": "jupiter guard",
    "horse assy": "horse assembly",
    "usd suspension": "usd suspension",
    "left penal": "left panel",
    "footrest rood": "footrest rod",
    "200 4v meter": "200 4v speedometer",
    "v belt drive": "v-belt drive",
    "scooter nitro": "scooter nitro",
    "tvs fiero fx": "tvs fiero fx",
    "gair chanjer": "gear changer",
    "oil 1200ml": "engine oil 1200ml",
    "ap ache 160 2v": "apache 160 2v",
    "accmouting": "accessories",
    "ari fillter": "air filter",
    "ntorq belts": "ntorq belt",
    "pep+spares mrp": "pep plus spares mrp",
    "mudguards": "guard",
    "nekal guard": "knee guard",
    "engen oil": "engine oil",
    "raida chang": "raider gear change",
    "trim panel left": "left trim panel",
    "n torq foot rest": "ntorq footrest",
    "ti shirt iqube": "t-shirt iqube",
    "parts exlater": "parts",
    "rtr 200 4v": "rtr 200 4v",
    "tyre ring": "tyre ring",
    "raide headlight": "raider headlight",
    "sansadhan": "accessories",
    "carborator": "carburetor",
    "brake yoak": "brake yoke",
    "silencer guard": "silencer guard",
    "throttle cable": "throttle cable",
    "handale damper": "handlebar damper",
    "apache beg": "apache bag",
    "accelerator grip": "accelerator grip",
    "taming chain": "timing chain",
    "left fender": "left fender",
    "kick cpver": "kick cover",
    "raider meter": "raider speedometer",
    "break lever": "brake lever",
    "xl100 retro": "xl100 retro",
    "apache head lamp": "apache headlight",
    "dicky light": "tail light",
    "power switch": "power switch",
    "frant madkat": "guard",
    "bottom cover": "bottom cover",
    "digi meter": "digital speedometer",
    "key ignition": "ignition key",
    "starter motor": "starter motor",
    "meter assembly": "speedometer assembly",
    "cahain lube": "chain lubricant",
    "chain spoket": "chain sprocket",
    "tvs phoenix": "tvs phoenix",
    "shock upsar": "shock absorber",
    "fairing front": "front fairing",
    "self start": "self starter",
    "display glass": "display glass",
    "coal plate": "clutch plate",
    "apache mudgaurd": "guard",
    "spare prods": "spare parts",
    "drum break": "drum brake",
    "break liver": "brake lever",
    "tail lamp": "tail light",
    "jupiter kick": "jupiter kick starter",
    "tru 4 skuuta": "tru4 scooter oil",
    "clutch bearing": "clutch bearing",
    "bada stand": "main stand",
    "wego front": "wego front",
    "key switch": "key switch",
    "thermal sensor": "thermal sensor",
    "engin bel pata": "engine belt",
    "handel tee": "handlebar",
    "left indicator": "left indicator",
    "mirror radeon": "radeon mirror",
    "raider mirror": "raider mirror",
    "oil 1000ml": "engine oil 1000ml",
    "chains proket": "chain sprocket",
    "4way cleaner": "4-way cleaner",
    "chain spraket": "chain sprocket",
    "ntorq cable": "ntorq cable",
    "heat sensor": "temperature sensor",
    "ntorq handel": "ntorq handlebar",
    "rtr 160 mitter": "rtr 160 speedometer",
    "black+tapeset": "black tape set",
    "mudguard notroq": "guard",
    "pap plus": "pep plus",
    "mag weel": "mag wheel",
    "spear": "spare parts",
    "rh disc": "right disc",
    "chainset": "chain set",
    "ntorq xt": "ntorq xt",
    "exaust": "exhaust",
    "cdi": "cdi unit",
    "bodipart": "body parts",
    "ntrow": "ntorq",
    "aaron": "aaron",
    "fog lamp": "fog light",
    "falesar": "flasher",
    "ht coal": "ht coil",
    "injector": "injector",
    "oneway": "one way",
    "tvs tru4": "tvs tru4 oil",
    "madigard": "guard",
    "rpo": "rpo",
    "v belt": "v-belt",
    "madghat": "guard",
    "fairing": "fairing",
    "magneto": "magneto",
    "diki": "dickey",
    "ntorq hr": "ntorq hr",
    "mudoh": "guard",
    "2v visor": "2v visor",
    "horse": "horse",
    "mudgaurd": "guard",
    "tci unit": "tci unit",
    "3d logo": "3d logo",
    "horns": "horn",
    "10w30": "10w30 engine oil",
    "glow box": "glove box",
    "madgaad": "guard",
    "disc kit": "disc kit",
    "obd": "obd",
    "painal": "panel",
    "fan": "fan",
    "redon": "radeon",
    "cobin": "cabin",
    "horan": "horn",
    "motul c4": "motul c4 oil",
    "paldi": "paldi",
    "mudgurd": "guard",
    "mudo": "guard",
    "kbc 180": "kbc 180",
    "r-17 rim": "17 inch rim",
    "shopcer": "shock absorber",
    "rtr200": "rtr 200",
    "tru4": "tru4 oil",
    "tvs logo": "tvs logo",
    "vayaring": "visor",
    "axcel": "axle",
    "bmw": "bmw",
    "xp metar": "xp speedometer",
    "yoke": "yoke",
    "ktm": "ktm",
    "batryi": "battery",
    "mitar": "speedometer",
    "corn set": "chain set",
    "xp visor": "xp visor",
    "medguard": "guard",
    "turbo4": "tru4 oil",
    "phoenix": "phoenix",
    "waizar": "visor",
    "piston": "piston",
    "gearoil": "gear oil",
    "rtr 160": "rtr 160",
    "lamp": "lamp",
    "mudgud": "guard",
    "said box": "side box",
    "vavle": "valve",
    "zest110": "zest 110",
    "flasher": "flasher relay",
    "realy": "relay",
    "legurd": "leg guard",
    "guage": "gauge",
    "fearing": "fairing",
    "t stumb": "t-stump",
    "zrst 110": "zest 110",
    "kalage": "kalage",
    "leg gard": "leg guard",
    "tcu unit": "tcu unit",
    "winsiter": "windshield",
    "audio": "audio system",
    "marghat": "guard"
};
  if (corrections[userSearchTerm]) {
    userSearchTerm = corrections[userSearchTerm];
  }
  // console.log("CASE 5", this.input.value.trim());
  return userSearchTerm;
}

    /**
     * Handles search form submit.
     * @param {object} evt - Event object.
     */
    handleSubmit(evt) {
      if (
        !this.getQuery().length
        || this.querySelector('.predictive-search__item[aria-selected="true"]:not(.js-submit)')
      ) {
        evt.preventDefault();
      }
    }

    /**
     * Handles 'input' events on the search field.
     */
    handleInput() {
      // autocomplete=off prevents browser from restoring value after using back button in Safari
      this.input.setAttribute('value', this.input.value);
      // console.log("CASE 6", this.input.setAttribute('value', this.input.value));

      const searchTerm = this.getQuery();
      // console.log("CASE 7", searchTerm);

      if (!searchTerm.length) {
        this.close();
        return;
      }

      this.getResults(searchTerm);
    }

    /**
     * Handles a change of product type
     * @param {object} evt - Event object.
     */
    handleProductTypeChange(evt) {
      this.productTypeInput.value = evt.detail.selectedValue;
      const query = this.getQuery();
      // console.log("CASE 8", this.productTypeInput.value, query);
      if (query.length > 0) {
        this.getResults(query);
      }
    }

    /**
     * Handles 'focus' events on the search field.
     */
    handleFocus() {
      const searchTerm = this.getQuery();
      // console.log("CASE 9", searchTerm);
      if (!searchTerm.length) return;

      if (this.getAttribute('results') === 'true') {
        this.open();
      } else {
        this.getResults(searchTerm);
      }
    }

    /**
     * Handles 'keydown' events on the custom element.
     * @param {object} evt - Event object.
     */
    handleKeydown(evt) {
      console.log("CASE 10", evt);
      // Let tabs script handle keydown events on the tab buttons.
      if (evt.target.matches('.tablist__tab')) return;

      switch (evt.key) {
        case 'ArrowUp':
        case 'ArrowDown':
          evt.preventDefault();

          if (this.hasAttribute('open')) {
            this.handleResultsNav(evt.key);
          }
          break;

        case 'Enter':
          this.selectOption();
          break;

        case 'Escape':
          this.close();
          break;

        // no default
      }
    }

    /**
     * Handles 'keyup' events on the custom element.
     */
    handleKeyup() {
      // If search field is empty after key press, close the results.
      if (!this.getQuery().length) this.close();
    }

    /**
     * Handles keyboard navigation of the results.
     * @param {string} key - Key pressed.
     */
    handleResultsNav(key) {
      console.log("CASE 11", key);
      const selectedResult = this.querySelector(
        '[role="tabpanel"]:not([hidden]) [aria-selected="true"]'
      );
      const allResults = this.querySelectorAll(
        '[role="tabpanel"]:not([hidden]) .predictive-search__item'
      );
      let resultToSelect = allResults[0];

      if (key === 'ArrowUp') {
        if (!selectedResult) return;

        // Select the next result up or the last one if we've reached the top of the list.
        resultToSelect = selectedResult.previousElementSibling || allResults[allResults.length - 1];
      } else if (key === 'ArrowDown') {
        if (selectedResult) {
          // Select the next result down or the first one if we've reached the bottom of the list.
          resultToSelect = selectedResult.nextElementSibling || allResults[0];
        }
      }

      this.statusEl.textContent = '';

      if (resultToSelect) {
        // If the selected item didn't change, do nothing.
        if (resultToSelect === selectedResult) return;

        resultToSelect.setAttribute('aria-selected', 'true');
        if (selectedResult) selectedResult.setAttribute('aria-selected', 'false');

        this.setLiveRegionText(resultToSelect.textContent);
        this.input.setAttribute('aria-activedescendant', resultToSelect.id);
      }
    }

    /**
     * Selects a result
     */
    selectOption() {
      const selectedResult = this.querySelector('[aria-selected="true"] > .js-search-link');
      if (selectedResult) selectedResult.click();
    }

    /**
     * Gets the results for a search term.
     * @param {string} searchTerm - Search query.
     */
    async getResults(searchTerm) {
      this.setLiveRegionLoadingState();

      let searchFields = 'title,product_type,variants.title,vendor';
      if (theme.settings.pSearchIncludeSkus) searchFields += ',variants.sku';
      if (theme.settings.pSearchIncludeTags) searchFields += ',tag';

      let searchParams = '';
      if (this.productTypeInput && this.productTypeInput.value !== '') {
        searchParams = `q=product_type:${encodeURIComponent(this.productTypeInput.value)} AND ${encodeURIComponent(searchTerm)}`;
      } else {
        searchParams = `q=${encodeURIComponent(searchTerm)}`;
      }

      searchParams += `&${encodeURIComponent('resources[limit]')}=${theme.settings.pSearchLimit}`;
      searchParams += `&${encodeURIComponent('resources[limit_scope]')}=${
        theme.settings.pSearchLimitScope
      }`;
      searchParams += `&${encodeURIComponent('resources[options][fields]')}=${searchFields}`;
      searchParams += '&section_id=predictive-search';

      const queryKey = searchParams.replace(' ', '-').toLowerCase();
      if (this.cachedResults[queryKey]) {
        this.renderResults(this.cachedResults[queryKey]);
        return;
      }

      try {
        const response = await fetch(`${theme.routes.predictiveSearch}?${searchParams}`);
        if (!response.ok) throw new Error(response.status);

        const tmpl = document.createElement('template');
        tmpl.innerHTML = await response.text();

        const resultsEl = tmpl.content.querySelector('#shopify-section-predictive-search');
        const resultsMarkup = resultsEl.innerHTML.replace(/psearch/g, this.input.id);

        this.cachedResults[queryKey] = resultsMarkup;
        this.renderResults(resultsMarkup);
      } catch (error) {
        this.close();
        throw error;
      }
    }

    /**
     * Sets the live region loading state.
     */
    setLiveRegionLoadingState() {
      this.setLiveRegionText(this.loadingText);
    }

    /**
     * Sets the live region text.
     * @param {string} statusText - Status text.
     */
    setLiveRegionText(statusText) {
      this.statusEl.setAttribute('aria-hidden', 'false');
      this.statusEl.textContent = statusText;

      setTimeout(() => {
        this.statusEl.setAttribute('aria-hidden', 'true');
      }, 1000);
    }

    /**
     * Renders the results markup.
     * @param {string} resultsMarkup - Results markup.
     */
    renderResults(resultsMarkup) {
      this.results.innerHTML = resultsMarkup;
      this.setAttribute('results', true);
      this.open();
    }

    /**
     * Opens the results listbox.
     */
    open() {
      this.overlay.classList.add('is-visible');
      if (this.getQuery().length) this.resetBtn.hidden = false;
      this.input.setAttribute('aria-expanded', 'true');
      this.setAttribute('open', '');
      document.body.classList.add('overlay-predictive-search');

      // Add event handlers (so the bound event listeners can be removed).
      this.keydownHandler = this.keydownHandler || this.handleKeydown.bind(this);
      this.keyupHandler = this.keyupHandler || this.handleKeyup.bind(this);
      this.resetBtnClickHandler = this.resetBtnClickHandler || this.close.bind(this);
      this.overlayClickHandler = this.overlayClickHandler || this.close.bind(this);

      // Add event listeners (for while results are open).
      this.addEventListener('keydown', this.keydownHandler);
      this.addEventListener('keyup', this.keyupHandler);
      this.resetBtn.addEventListener('click', this.resetBtnClickHandler);
      this.overlay.addEventListener('click', this.overlayClickHandler);
    }

    /**
     * Closes the results listbox.
     * @param {object} evt - Event object.
     */
    close(evt) {
      // If reset button was clicked, empty the input field.
      if (evt && evt.target === this.resetBtn) {
        this.input.value = '';
        this.removeAttribute('results');
        this.input.focus();
      }

      // Deselect the selected result (if there is one).
      const selected = this.querySelector('.predictive-search__item[aria-selected="true"]');
      if (selected) selected.setAttribute('aria-selected', 'false');

      this.removeAttribute('open');
      //this.resetBtn.hidden = true;
      this.overlay.classList.remove('is-visible');
      this.input.setAttribute('aria-activedescendant', '');
      this.input.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('overlay-predictive-search');

      // Remove event listeners added on search results opening.
      this.removeEventListener('keydown', this.keydownHandler);
      //this.resetBtn.removeEventListener('click', this.resetBtnClickHandler);
      this.overlay.removeEventListener('click', this.overlayClickHandler);
    }
  }

  customElements.define('predictive-search', PredictiveSearch);
}
